import React from 'react';
import { TrendingUp, DollarSign, Rocket, AlertTriangle } from 'lucide-react';

const MetricsCards = ({ data, loading }) => {
  const formatCurrency = (cents) => {
    if (!cents) return '$0';
    const dollars = cents / 100;
    if (dollars >= 1000000000) {
      return `$${(dollars / 1000000000).toFixed(1)}B`;
    } else if (dollars >= 1000000) {
      return `$${(dollars / 1000000).toFixed(1)}M`;
    } else if (dollars >= 1000) {
      return `$${(dollars / 1000).toFixed(1)}K`;
    }
    return `$${dollars.toFixed(0)}`;
  };

  const metrics = [
    {
      label: 'Active Programs',
      value: data?.active_programs || 0,
      subtitle: data?.active_programs_source === 'pipeline' ? 'Pipeline programs' : 'Part records',
      icon: TrendingUp,
      color: 'blue',
      bgColor: 'bg-blue-50',
      iconColor: 'text-blue-600',
    },
    {
      label: 'Total Annual Revenue',
      value: formatCurrency(data?.total_annual_revenue),
      icon: DollarSign,
      color: 'green',
      bgColor: 'bg-green-50',
      iconColor: 'text-green-600',
    },
    {
      label: 'Launching Next 12mo',
      value: data?.launching_next_12_months || 0,
      icon: Rocket,
      color: 'purple',
      bgColor: 'bg-purple-50',
      iconColor: 'text-purple-600',
    },
    {
      label: 'At-Risk Programs',
      value: data?.at_risk_programs || 0,
      icon: AlertTriangle,
      color: 'red',
      bgColor: 'bg-red-50',
      iconColor: 'text-red-600',
    },
  ];

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-2/3 mb-4"></div>
            <div className="h-8 bg-gray-200 rounded w-1/2"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {metrics.map((metric, index) => {
        const Icon = metric.icon;
        return (
          <div
            key={index}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow"
          >
            <div className="flex items-center justify-between mb-4">
              <span className="text-sm font-medium text-gray-600">{metric.label}</span>
              <div className={`${metric.bgColor} p-2 rounded-lg`}>
                <Icon className={`w-5 h-5 ${metric.iconColor}`} />
              </div>
            </div>
            <div className="text-3xl font-bold text-gray-900">
              {metric.value}
            </div>
            {metric.subtitle && (
              <div className="mt-1 text-xs text-gray-500">{metric.subtitle}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MetricsCards;
